export default function () {
  this.loadProfessional()
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/identification/resources/mounted.js